import React from 'react'
import {
  IconButton,
  Tooltip,
  Typography,
  Box
} from '@mui/material'
import { makeStyles, withStyles } from '@mui/styles'
import { InfoOutlined } from '@mui/icons-material'

const DiffTooltip = withStyles({
  tooltip: {
    fontSize: 14
  }
})(Tooltip)

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    justifyContent: 'center',
    marginTop: '-30px',
    marginBottom: '8px'
  },
  item: {
    display: 'flex',
    alignItems: 'center'
  },
  iconButton: {
    padding: '8px'
  },
  text: {
    fontWeight: 'bold',
    marginLeft: '4px'
  }
})

interface DiffItem {
  title: string
  label: string
  ariaLabel: string
}

const diffItems: DiffItem[] = [
  {
    title: 'Se declara que existen unidades no encontradas las cuales se enviarán a ubicación de diferencia.',
    label: 'DECLARAR FALTANTE',
    ariaLabel: 'Declarar faltante'
  },
  {
    title: 'Se identifica un producto con daño por lo que se enviará a calidad, gestionar desde "Alertas de inventario".',
    label: 'ENVIAR A CALIDAD',
    ariaLabel: 'Enviar a calidad'
  },
  {
    title: 'Se identifica un producto con rechazo comercial por lo que se enviara a calidad, gestionar desde "Alertas de inventario".',
    label: 'RECHAZO COMERCIAL',
    ariaLabel: 'Rechazo comercial'
  }
]

export const PickingDiffereceExplain = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      {diffItems.map((item, index) => (
        <Box key={index} className={classes.item}>
          <DiffTooltip title={item.title} aria-label={item.ariaLabel}>
            <IconButton className={classes.iconButton}>
              <InfoOutlined color='error' fontSize='large' />
            </IconButton>
          </DiffTooltip>
          <Typography variant='body2' className={classes.text}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}
